import React from "react";
import { hydrate } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./style.scss";
hydrate(React.createElement(BrowserRouter, null,
    React.createElement(App, null)), document.getElementById("root"));
if (module.hot) {
    module.hot.accept();
}
